/** * liensPlus.js */// Importimport "./liensPlus.scss";import $ from 'jquery';$(document).ready(function() {});